export const NAV_MAIN=[
  {label:'Dashboard',to:'/dashboard'},
  {label:'Customers',to:'/customers'},
  {label:'Products',to:'/products'},
  {label:'Sales',to:'/sales'},
  {label:'Invoice',to:'/invoice'},
  {label:'Credit',to:'/credit'},
  {label:'Reports',to:'/reports'}
];
export const NAV_QUICK=[
  {label:'POS',to:'/pos'},
  {label:'Returns',to:'/returns'}
];
